export const PATCH_NOTES_URL = 'https://www.rooms.chat/';
